module.exports = __webpack_public_path__ + "media/images/icons8-qr-code-215a6ea2e9e27e87a2624c88660a3d09.svg";